import { DURATION_POLL_INTERVAL_MS, DURATION_POLL_MAX_MS, HAVE_METADATA } from "./constants";

// audio -> state: the <audio> element's events update state, then render().
export function bindAudioEvents(player) {
    const { audio, state, track, render, actions } = player;

    let pollInterval;
    let pollDeadline;

    const hasDuration = () => Number.isFinite(audio.duration) && audio.duration > 0;

    function stopPolling() {
        clearInterval(pollInterval);
        clearTimeout(pollDeadline);
        pollInterval = pollDeadline = undefined;
    }

    function syncFromElement() {
        if (audio.readyState >= HAVE_METADATA) {
            state.duration = Number.isFinite(audio.duration) ? audio.duration : 0;
            state.currentTime = audio.currentTime;
        }
        if (audio.error) {
            actions.trackErrorOnce();
            actions.setError(true);
        }
        if (hasDuration() || audio.error) stopPolling();
        render();
    }

    function startDurationPolling() {
        if (hasDuration()) return;
        pollInterval = setInterval(syncFromElement, DURATION_POLL_INTERVAL_MS);
        pollDeadline = setTimeout(stopPolling, DURATION_POLL_MAX_MS);
    }

    audio.addEventListener("play", () => {
        state.isPlaying = true;
        track("play");
        render();
    });
    audio.addEventListener("pause", () => {
        state.isPlaying = false;
        actions.stopBuffering();
        track("pause");
        render();
    });
    audio.addEventListener("loadedmetadata", () => {
        state.duration = Number.isFinite(audio.duration) ? audio.duration : 0;
        audio.playbackRate = state.playbackRate; // browsers may reset it on metadata
        render();
    });
    audio.addEventListener("durationchange", syncFromElement);
    audio.addEventListener("timeupdate", () => {
        state.currentTime = audio.currentTime;
        render();
        // TODO: progress milestones from usePodcastTracking.onTimeUpdate
    });
    audio.addEventListener("ended", () => {
        state.isPlaying = false;
        state.currentTime = 0;
        actions.stopBuffering();
        track("ended");
        render();
    });
    audio.addEventListener("error", () => {
        state.isPlaying = false;
        actions.stopBuffering();
        actions.trackErrorOnce();
        actions.setError(true);
    });
    audio.addEventListener("waiting", actions.startBuffering);
    const clearBuffering = () => {
        actions.stopBuffering();
        render();
    };
    audio.addEventListener("playing", clearBuffering);
    audio.addEventListener("canplay", clearBuffering);
    audio.addEventListener("volumechange", () => {
        state.volume = audio.volume;
        state.isMuted = audio.muted;
        render();
    });
    audio.addEventListener("ratechange", () => {
        state.playbackRate = audio.playbackRate;
        render();
    });

    return { syncFromElement, startDurationPolling };
}
